import React, { useState } from 'react';
import { KeyValue } from 'mediadb-models';
import { useEffectOnce } from 'react-use';
import * as journalistSearchLogService from '@/services/journalist-search-log.service';
import * as outletSearchLogService from '@/services/outlet-search-log.service';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import { defaultChartOptions, isSeriesHidden } from '@/components/charts-options';
import HighchartsReact from 'highcharts-react-official';

export default function QueryCount({fromDate}: {
    fromDate: Date
}) {
    const [journalistQueryCount, setJournalistQueryCount] = useState<KeyValue[]>([]);
    const [outletQueryCount, setOutletQueryCount] = useState<KeyValue[]>([]);

    useEffectOnce(() => {
        journalistSearchLogService.getQueryCount(fromDate).then(setJournalistQueryCount);
        outletSearchLogService.getQueryCount(fromDate).then(setOutletQueryCount);
    });

    const chartTitle = 'Query Count';

    const queryCountOptions: Highcharts.Options = {
        ...defaultChartOptions,
        chart: {
            type: 'line',
            ...defaultChartOptions.chart,
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            type: 'datetime'
        },
        yAxis: {
            gridLineDashStyle: 'Dash',
            allowDecimals: false,
            title: {
                text: 'Query Count'
            }
        },
        series: [
            {
                type: 'line',
                name: 'Journalist Query Count',
                data: journalistQueryCount.map(a => ({
                    x: new Date(a.key).getTime(),
                    y: a.value
                })),
            },
            {
                type: 'line',
                name: 'Outlet Query Count',
                data: outletQueryCount.map(a => ({
                    x: new Date(a.key).getTime(),
                    y: a.value
                })),
            }
        ].map(s => ({
            ...s,
            visible: !isSeriesHidden(chartTitle, s.name)
        } as SeriesOptionsType)),
    };

    return <HighchartsReact highcharts={Highcharts} options={queryCountOptions}/>;
}
